<template>
  <div>
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <div>
        <Breadcrumbs
          v-if="classData"
          :data="classData.title"
          :headline="classData.title"
          :link="[
            { text: 'Lớp học', href: '../../../classes' },
            {
              text: classData.title,
              id: classData.id,
              href: `../../class/${classData.id}`
            },
            { text: 'Học viên' }
          ]"
        />
      </div>
      <div
        class="d-flex justify-end"
        v-if="['super_admin', 'education_manager'].includes(role.type)"
      >
        <student-list-actions :selected="selected" />
      </div>
    </div>

    <v-card elevation="1" class="mx-md-2 mt-2">
      <v-data-table
        flat
        dense
        item-key="id"
        v-model="selected"
        :show-select="['education_manager', 'super_admin'].includes(role.type)"
        :headers="headers"
        :items="students"
        class="mt-3 px-4"
        @click:row="onSelected"
        :disable-pagination="true"
        :hide-default-footer="true"
      >
        <!-- :items-per-page="-1" -->
        <v-layout slot="top">
          <v-flex xs10 sm8 md8 class="px-6">
            <student-mark-dialog :mark="mark" :state="dialog"></student-mark-dialog>
          </v-flex>
          <v-spacer />
          <v-flex xs2 sm2 md2 class="d-flex flex-row-reverse">
            <drop-menu></drop-menu>
          </v-flex>
        </v-layout>
        <template v-slot:item.index="{ item }">
          {{ students.indexOf(item) + 1 }}
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip :color="getColor(item.status)" dark>{{ item.status }}</v-chip>
        </template>
        <template v-slot:item.name="{ item }">
          <user-item :student="item" link></user-item>
        </template>
        <template v-slot:item.gender="{ item }">{{
          item.gender === 'male' ? 'Nam' : item.gender === 'female' ? 'Nữ' : 'Khác'
        }}</template>
        <template v-slot:item.action="{ item }">
          <v-btn text icon @click="onStudentSelected(item)">
            <v-icon dense>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import StudentListActions from '@/modules/class/student/StudentListActions'
import UserItem from '@/components/basic/card/CardStudentName.vue'
import StudentMarkDialog from '@/modules/student/mark/StudentMarkDialog.vue'
import DropMenu from '@/modules/class/student/Menu.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
export default {
  components: {
    UserItem,
    StudentListActions,
    StudentMarkDialog,
    DropMenu,
    Breadcrumbs
  },
  data() {
    return {
      headers: [
        { text: 'STT', value: 'index', align: 'center', sortable: false },
        { text: 'Tên', value: 'name', align: 'left', sortable: false },
        { text: 'Email', value: 'email', align: 'left', sortable: false },
        {
          text: 'Số Điện Thoại',
          value: 'phone',
          align: 'left',
          sortable: false
        },
        { text: 'Giới tính', value: 'gender', align: 'left', sortable: false }
      ],
      selected: [],
      mark: {},
      dialog: false,
      search: '',
      status: null,
      statuses: [
        { text: 'Active', value: 'false' },
        { text: 'Blocked', value: 'true' }
      ],
      range: { from: null, to: null },
      previewUserId: null,
      ready: false,
      studentTableOptions: {}
    }
  },
  async created() {
    const classId = this.$route.params.id
    this.initClass({ id: classId })
  },
  computed: {
    ...mapState('app', ['department']),
    ...mapState('classDetail', ['marks']),
    ...mapState('auth', ['user', 'role']),
    ...mapGetters('classDetail', ['classData', 'slots', 'classList', 'students'])
  },
  methods: {
    ...mapActions('classDetail', ['fetchClass', 'updateClass', 'createAttendance', 'initClass']),
    onSelected(student) {
      this.mark = this.marks[student.id]
      if (!this.mark) return
      this.dialog = !this.dialog
    },
    getColor(status) {
      if (status === 'active') return 'green'
      else return 'red'
    }
  }
}
</script>
